import { render, staticRenderFns } from "./ChamadosForm.vue?vue&type=template&id=576de669&scoped=true&lang=pug&"
import script from "./ChamadosForm.vue?vue&type=script&lang=js&"
export * from "./ChamadosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576de669",
  null
  
)

export default component.exports